import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import ReferralRewardsAPI from '@/apps/order/classes/api/ReferralRewardsAPI';
import ReferralRewardInterface from '@/apps/order/interfaces/ReferralRewardInterface';
import FeatureAPI from '@/apps/order/classes/api/FeatureAPI';

const useFeatureStore = defineStore('features', () => {
  const features = ref<string[]>([]);
  const referralMarketingIsActive = computed(() => features.value.includes('order.referralMarketing'));
  const fetch = (): Promise<string[]> => new Promise((resolve, reject) => {
    FeatureAPI.fetch().then((fetchedFeatures: string[]) => {
      features.value = fetchedFeatures;
      resolve(fetchedFeatures);
    }).catch((e) => {
      reject(e);
    });
  });

  const referralMarketingRewards = ref<ReferralRewardInterface[]>([]);
  const referrerRewards = computed(() => referralMarketingRewards.value.filter((reward) => reward.referrer === true));
  const customerRewards = computed(() => referralMarketingRewards.value.filter((reward) => reward.customer === true));

  const fetchReferralMarketingRewards = (brandId: number): Promise<ReferralRewardInterface[]> => new Promise<ReferralRewardInterface[]>((resolve, reject) => {
    if (!referralMarketingIsActive.value) {
      resolve([]);
    }

    ReferralRewardsAPI.fetch(brandId).then((rewards) => {
      referralMarketingRewards.value = rewards;
      resolve(rewards);
    }).catch((e) => {
      reject(e);
    });
  });

  const isEnabled = (featureName: string) => features.value.includes(featureName);

  const customFieldsFeatureActive = computed(() => isEnabled('customFields'));

  const getCustomFieldsForReward = (rewardValue?: string | number) => {
    if (!rewardValue) return [];
    const reward = referralMarketingRewards.value.find((r) => r.value === `${rewardValue}`);
    return reward?.customFields || [];
  };

  return {
    features,
    isEnabled,
    fetch,
    referralMarketingIsActive,
    referralMarketingRewards,
    referrerRewards,
    customerRewards,
    fetchReferralMarketingRewards,
    customFieldsFeatureActive,
    getCustomFieldsForReward,
  };
});

export default useFeatureStore;
